export const TermsAndCondition_Description_Ttile_1 = `
Use of Website and Services
`;

export const TermsAndCondition_Description_Description_1 = `
By accessing or using the Air Runner website, mobile platforms, or booking systems, you agree to comply with all applicable terms, policies, and aviation regulations. Air Runner reserves the right to update, modify, or restrict access to its services at any time without prior notice.
`;



export const TermsAndCondition_Description_Ttile_2 = `
Bookings, Fares, and Payments
`;

export const TermsAndCondition_Description_Description_2 = `
All flight bookings made with Air Runner are subject to availability, fare rules, and confirmation at the time of purchase. Fares displayed on the website may vary based on demand, route, season, or promotional offers and are inclusive or exclusive of taxes as stated during booking. Passengers must ensure that personal details such as name, date of travel, and contact information are accurate before completing payment. Once a booking is confirmed, changes or corrections may attract additional charges as per the fare conditions. Air Runner reserves the right to cancel or modify bookings in cases of suspected fraud, pricing errors, or non-compliance with payment obligations.
`;



export const TermsAndCondition_Description_Ttile_3 = `
Cancellations, Refunds, and No-Show Policy
`;

export const TermsAndCondition_Description_Description_3 = `
Cancellation and refund eligibility depends on the type of fare purchased. Refundable fares may be canceled within the specified timeframe, subject to applicable service charges, while non-refundable fares may only qualify for partial refunds or travel credits. In case of a no-show, Air Runner reserves the right to forfeit the entire ticket value unless otherwise stated.
`;



export const TermsAndCondition_Description_Ttile_4 = `
Schedule Changes and Service Disruptions
`;

export const TermsAndCondition_Description_Description_4 = `
Air Runner may alter flight schedules, routes, or aircraft types due to operational requirements, weather conditions, air traffic restrictions, safety considerations, or regulatory directives. While Air Runner makes reasonable efforts to inform passengers of such changes using the contact details provided at the time of booking, the airline shall not be held liable for indirect losses, including missed connections, accommodation costs, or alternative travel arrangements. In the event of significant delays, cancellations, or denied boarding, Air Runner will offer assistance, rebooking options, or refunds in accordance with its customer service policies and applicable aviation laws.
`;



export const TermsAndCondition_Description_Ttile_5 = `
Passenger Responsibilities and Conduct
`;

export const TermsAndCondition_Description_Description_5 = `
Passengers traveling with Air Runner are responsible for complying with all safety instructions, crew directions, and airport regulations throughout their journey. Proper travel documentation, including valid identification, visas, and permits, must be carried at all times. Any disruptive, unsafe, or unlawful behavior may result in denied boarding, removal from the aircraft, or further legal action, without entitlement to compensation.
`;